//  和用户相关的状态管理

import { createSlice } from '@reduxjs/toolkit'
import { setMenuList as _setMenuList, getMenuList, setPathList as _setPathList, getPathList, setMenuPathList as _setMenuPathList, getMenuPathList, setButtonList as _setButtonList, getButtonList } from '@/utils/menu'
import { getUserMenuListAPI } from '@/apis/user'

const permissionStore = createSlice({
  name: 'permission',
  //  数据状态
  initialState: {
    menuList: getMenuList() || [],
    pathList: getPathList() || {},
    menuPathList: getMenuPathList() || [],
    buttonList: getButtonList() || []
  },
  //  同步修改方法
  reducers: {
    setMenuList(state, action) {
      state.menuList = action.payload
      _setMenuList(action.payload)
    },
    setPathList(state, action) {
      state.pathList = action.payload
      _setPathList(action.payload)
    },
    setMenuPathList(state, action) {
      state.menuPathList = action.payload
      _setMenuPathList(action.payload)
    },
    setButtonList(state, action) {
      state.buttonList = action.payload
      _setButtonList(action.payload)
    },
  }
})

//  解构出actionCreater
const { setMenuList, setPathList, setMenuPathList, setButtonList } = permissionStore.actions

//  获取reducer函数
const permissionReducer = permissionStore.reducer

//  异步请求方法 完成登录获取token
const fetchMenuList = () => {
  return async dispatch => {
    //  1. 发送异步请求
    const res = await getUserMenuListAPI()
    if (res.success === true) {
      if (res.result.length === 0) {
        //removeMenuList()//  删除菜单缓存
        return false;
      }
      //  处理菜单数据
      let menuList = []// 左侧菜单
      let pathList = {}// 页面路由表
      let menuPathList = []//  所有权限菜单路径
      let buttonList = []//  按钮权限
      res.result.forEach((item, index) => {
        let menu = {
          label: item.name,
          icon: item.icon,
          key: "p" + index
        }
        if (item.children) {
          menu.children = []
          item.children.forEach(child => {
            let key = '/managecenter/' + child.path
            menuPathList.push(key)
            //child.key = key

            if (!child.hidden) {
              menu.children.push({
                label: child.name,
                key
              })
            }
            if(child.children.length > 0){
              child.children.forEach(ele => {
                ele.path = '/managecenter/' + ele.path
                menuPathList.push(ele.path)
                
                if(ele.buttonList.length > 0) {
                  buttonList.push(...ele.buttonList.map(e => e.type))
                }
              })
              pathList[key] = child.children
            }
            if(child.buttonList.length > 0) {
              buttonList.push(...child.buttonList.map(e => e.type))
            }
          })
        }
        menuList.push(menu)
      })
      
      //  2. 提交同步action进行存入
      dispatch(setMenuList(menuList))
      dispatch(setPathList(pathList))
      dispatch(setMenuPathList(menuPathList))
      dispatch(setButtonList(buttonList))
    }
  }
}

export { fetchMenuList, setMenuList, setPathList, setMenuPathList, setButtonList }

export default permissionReducer
